import React from 'react';
import {Typography} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Typography)(() => ({
  whiteSpace: 'normal',
}));

type CollapsableCardValueProps = React.ComponentPropsWithoutRef<'h6'>

/**
 * MUI Typography based styled component. Used for the value of the corresponding label text fields inside the Card
 * @param children children passed through to the internal Typography component
 * @param rest The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const CollapsableCardValue = ({ children, ...rest}: CollapsableCardValueProps) => {
  return <Root variant={'h6'} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardValue };
